module.exports = __webpack_public_path__ + "assets/img/score.c8359535.png";